import(/* webpackMode: "eager" */ "/woodpecker/src/github.com/wisflux/school-erp/packages/parent-frontend/src/app/not-found.tsx");
